export const BASE_CONFIG = {
  // SERVICE_URL: "http://192.168.197.160:7601/apigateway/", // Without Encryption private url
  // SERVICE_URL: "http://192.168.197.160:7602/encapigateway/", // With Encryption private url
  //  SERVICE_URL: "https://tigios.techurate.com/product-service",
  //  SERVICE_URL: "https://onlineuat.salaambank.co.ug/apigateway/",  // Without Encryption public url
  SERVICE_URL: "https://online.salaambank.co.ug/encapigateway/",  //polit url
  ENCRYPT_ENABLE: true,

  SESSION_TIME_OUT: 180000,
  APP_DEFAULT_LANGUAGE: "en",
  ENCRYPT_KEY: "20E38214tC181205",
  GCM_KEY: "BCBINDIAVER12022",
  GOOGLE_MAPS_API_KEY: "AIzaSyD94dYAJU4hkOyMi3mz6QGWxUsqkAx-9Ag",
  OTP_TIMER: 180,
  OTP_LENGTH: 4,
  MAX_TRANSFER_LIMIT: 99999999,
  CURRENCY_LIST: ["UGX", "USD", "GBP", "EUR", "KES"],
  CURRENCY: "UGX",
  BANK_NAME: "Salaam Bank Limited",
  BRANCH_NAME: "Head Office",
  BRANCH_CODE: "001",
  DEFAULT_OTP: "0000",
  DEFAULT_MOBILE_PREFIX: "256",
  ACCOUNT_NUMBER_MAX_LENGTH: 10,
  ACCOUNT_NO_MIN_LENGTH: 9,
  PAYMENT_OPTION: true,
  WALLET_MOBILE_LENGTH: 10,

  MOBILE_NO_LENGTH: 10,
  QUICK_LINKS_OPTIONS: {
    ACCOUNTS: "accounts",
    BILLPAYMENT: "bill-payment",
    DASHBOARD: "dashboard",
    FUNDTRANSFER: "send-money",
    GEPG: "government-payment",
    LOAN: "loans",
    PENDINGAPPROVALS: "pending-authorization",
    PORTFOLIO: "portfolio",
  },
  ASSETS_TYPES: ["SA", "CA", "T", "FD", "ODA", "WA"],
  LIABILITIES_TYPES: ["LA"],
  ENABLE_TENENT: false,
  LANGUAGE_LIST: ["en", "fr",], //  "so","ar","sw"
  LANGUAGE_SELECTION: false,
  BENE_NICKNAME_LENGTH: 50,
  SLOGAN:"Grow into your greatness, bank with us!",
  BANK_CARD:true,
  CIF: false,
  EXCHANGE_RATE_COMING_SOON: false,
  CROSS_CURRENCY: false,
  FORGET_USERNAME_MOBILE: true,
  CALCULATE_DEPOSIT: false,
  REFUGEEID: true,
  PASSWORD_MIN_LENGTH: 6,
  PASSWORD_MAX_LENGTH: 16,
  CALCULATE_SLIDER: false,
};
